import { water } from 'src/modules/user-input/calcV100/constants.ts';
import { CalcFtHeadState } from 'src/modules/user-input/calcFtHead/types.ts';

export const initialState: CalcFtHeadState = {
    density: water.density,
    ftHead: '',
};
